import React, { useRef, useCallback } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Link } from 'react-router-dom';
import { formatDateOnly } from '../../../../../utils/dateUtils';
import { useLanguage } from '../../../../../contexts/LanguageContext';

const VehicleRegistrationFormTable = ({ vehicleRegistrationForms, loading, CVRFStatus, onPage, onSort, lazyParams, totalRecords, tabLabel, handleShowHistory }) => {
    const dataTableRef = useRef(null);
    const columnsRef = useRef(null);

    const { th } = useLanguage();

    // Get columns when the DataTable mounts, not on every render
    const getColumnsCallback = useCallback((el) => {
        if (el && el.getColumns && !columnsRef.current) {
            columnsRef.current = el.getColumns();
        }
        dataTableRef.current = el;
    }, []);
    const actionBodyTemplate = (rowData) => {
        return (
            <div className="flex gap-2 justify-content-center align-items-center">
                <Link
                    to={`/warranty-management/warranty-process-forms/dealer-vehicle-registration-form/${rowData.id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-500 hover:text-blue-700"
                    title={th('common.edit')}
                >
                    <i className="pi pi-pencil cursor-pointer" style={{ fontSize: '1.1rem' }} />
                </Link>
                <i className="pi pi-history cursor-pointer text-blue-500 hover:text-blue-700" style={{ fontSize: '1.1rem' }} title={th('warrantyClaims.tooltips.history')} onClick={() => handleShowHistory(rowData)}></i>
            </div>
        );
    };

    return (
        <DataTable
            value={vehicleRegistrationForms}
            lazy
            paginator
            first={lazyParams.first}
            rows={lazyParams.rows}
            onPage={onPage}
            onSort={onSort}
            sortField={lazyParams.sortField}
            sortOrder={lazyParams.sortOrder}
            totalRecords={totalRecords}
            className="p-datatable-gridlines"
            showGridlines
            dataKey="id"
            loading={loading}
            filterDisplay="menu"
            stripedRows
            emptyMessage={th('warranty.dealerVehicleRegistrationForm.table.emptyMessage')}
            rowsPerPageOptions={[5, 10, 25, 50, 100, 500, 1000]}
            tableStyle={{ minWidth: '60rem' }}
            ref={getColumnsCallback}
        >
            <Column bodyClassName="text-center" headerClassName="text-center" body={actionBodyTemplate} exportable={false} style={{ width: '5%', minWidth: '33px' }} />
            <Column sortable field="dealerName" header={th('warranty.dealerVehicleRegistrationForm.table.dealerName')} />
            <Column sortable field="bosBranchCode" header={th('warranty.dealerVehicleRegistrationForm.table.dealerNo')} />
            <Column sortable field="chassisNo" header={th('warranty.dealerVehicleRegistrationForm.table.chassisNo')} />
            <Column sortable field="vehiclePlate" header={th('warranty.dealerVehicleRegistrationForm.table.vehiclePlate')} />
            <Column sortable field="kmInformation" header={th('warranty.dealerVehicleRegistrationForm.table.kmInformation')} />
            <Column sortable field="vehicleRegistration" header={th('warranty.dealerVehicleRegistrationForm.table.vehicleRegistration')} body={(rowData) => formatDateOnly(rowData.vehicleRegistration)} />
            <Column sortable field="nameCompany" header={th('warranty.dealerVehicleRegistrationForm.table.nameCompany')} />
            <Column sortable field="customerPhone" header={th('warranty.dealerVehicleRegistrationForm.table.customerPhone')} />
            <Column sortable field="customerEmail" header={th('warranty.dealerVehicleRegistrationForm.table.customerEmail')} />
            <Column sortable field="customerAddress" header={th('warranty.dealerVehicleRegistrationForm.table.customerAddress')} />
            <Column sortable field="customerStreet" header={th('warranty.dealerVehicleRegistrationForm.table.customerStreet')} />
            <Column sortable field="customerHome" header={th('warranty.dealerVehicleRegistrationForm.table.customerHome')} />
            <Column sortable field="customerCity" header={th('warranty.dealerVehicleRegistrationForm.table.customerCity')} />
            <Column sortable field="customerPostalCode" header={th('warranty.dealerVehicleRegistrationForm.table.customerPostalCode')} />
            <Column sortable field="customerCountry" header={th('warranty.dealerVehicleRegistrationForm.table.customerCountry')} />
            <Column sortable field="returnMsg" header={th('warranty.dealerVehicleRegistrationForm.table.returnMsg')} />
        </DataTable>
    );
};

export default VehicleRegistrationFormTable;
